import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { retryNon4xx } from "shared/api/query-retry";
import { offersAdminApi } from "../../api/offersAdminApi";
var KEYS = {
    all: ["admin", "offers"],
    filtered: function (filters) {
        return ["admin", "offers", "list", filters !== null && filters !== void 0 ? filters : {}];
    },
};
export var useAdminOffers = function (filters) {
    return useQuery({
        queryKey: KEYS.filtered(filters),
        queryFn: function () { return offersAdminApi.list(filters); },
        staleTime: 10000,
        retry: retryNon4xx,
    });
};
export var useDeleteOffer = function () {
    var qc = useQueryClient();
    return useMutation({
        mutationFn: function (offerId) { return offersAdminApi.deleteOne(offerId); },
        onSuccess: function () { return qc.invalidateQueries({ queryKey: KEYS.all }); },
    });
};
